import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';

@Component({
  selector: 'p8-file-picker',
  templateUrl: './file-picker.component.html',
  styleUrls: ['./file-picker.component.scss']
})
export class FilePickerComponent implements OnInit {
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  newFiles: FileList;

  @Input() files: File[] = [];
  @Input() accept = '*';
  /**
   * Taille maximale (cf. django settings) : 20 Mo, en bit
   */
  @Input() maxFileSize = 20000000;

  @Output() filesChange = new EventEmitter();

  constructor(private snackSvc: SnackBarToastyService) { }

  ngOnInit() {
  }

  updateFiles(event: Event) {
    this.newFiles = this.fileInput.nativeElement.files;
    for (let i = 0; i < this.newFiles.length; i++) {
      const fileOk = this.checkFileSize(this.newFiles.item(i));
      if (fileOk) {
        this.files.push(this.newFiles.item(i));
      } else {
        this.snackSvc.toasty('Fichier', 'Le fichier dépasse la taille maximale autorisée de 20 Mo', typeToast.error);
      }
    }
    this.filesChange.emit(this.files);
  }

  checkFileSize(file) {
    return !(this.maxFileSize && this.maxFileSize < file.size);
  }

  click() {
    this.fileInput.nativeElement.click();
  }


}
